import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  VideoPromoteChannelVo,
  VideoPromoteLanguageVo,
  VideoPromoteThemeAppVo,
  VideoThemeListRequest,
  VideoPromoteCalculateRequest,
  VideoPromoteCalculateVo,
  VideoPromoteSubmitBody,
  SubmitRecordRequest,
  VideoPromoteSubmitRecordVo
} from './type';

// 获取语言列表
// GET /affiliate/promote/languageList
// 接口ID：306218399
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-306218399
export const getAffiliateVideoLanguageList = (): AxiosPromise<VideoPromoteLanguageVo[]> => {
  return request({
    url: '/affiliate/promote/languageList',
    method: 'get'
  });
};

// 获取渠道列表
// GET /affiliate/promote/channelList
// 接口ID：306218400
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-306218400
export const getAffiliateVideoChannelList = (): AxiosPromise<VideoPromoteChannelVo[]> => {
  return request({
    url: '/affiliate/promote/channelList',
    method: 'get'
  });
};

// 主题列表
// GET /affiliate/promote/themeList
// 接口ID：306218397
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-306218397
export const getAffiliateVideoThemeList = (params: VideoThemeListRequest): AxiosPromise<VideoPromoteThemeAppVo[]> => {
  return request({
    url: '/affiliate/promote/themeList',
    method: 'get',
    params
  });
};

// 计算
// POST /affiliate/promote/calculate
// 接口ID：306218396
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-306218396
export const postAffiliateVideoCalculate = (data: VideoPromoteCalculateRequest): AxiosPromise<VideoPromoteCalculateVo> => {
  return request({
    url: '/affiliate/promote/calculate',
    method: 'post',
    data
  });
};

// 提交视频链接
// POST /affiliate/promote/submit
// 接口ID：306218395
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-
export const postAffiliateVideoLink = (data: VideoPromoteSubmitBody): AxiosPromise<boolean> => {
  return request({
    url: '/affiliate/promote/submit',
    method: 'post',
    data
  });
};

// 提交记录
// GET /affiliate/promote/submitRecord
// 接口ID：306218398
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-306218398
export const getAffiliateVideoSubmitRecord = (params: SubmitRecordRequest): AxiosPromise<VideoPromoteSubmitRecordVo[]> => {
  return request({
    url: '/affiliate/promote/submitRecord',
    method: 'get',
    params
  });
};
